import { doodBlockConfig, propertyValue } from "./dood-block-config";
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from "./descriptor-field-order";
import type { IBlockDescriptor } from "./descriptor";

export const KIOSKLOYALTYCONNECTIONBLOCK_LEGACY_FIELD_ORDER = [
  "title",
  "first_card_label",
  "first_card_link",
  "second_card_label",
  "second_card_link",
  "display_third_card",
  "third_card_label",
  "third_card_link",
  { type: "separator" },
  "heading_text_color",
  "main_card_background_color",
  "main_card_text_color",
  "secondary_card_background_color",
  "secondary_card_text_color",
  "third_card_background_color",
  "third_card_text_color",
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  kioskLoyaltyConnectionBlockDescriptor: _generatedKioskLoyaltyConnectionBlockDescriptor,
  kioskLoyaltyConnectionBlockBlocDefinition,
  kioskLoyaltyConnectionBlockDashboardLayout,
  kioskLoyaltyConnectionBlockConfig,
  kioskLoyaltyConnectionBlockResolveConfig,
  kioskLoyaltyConnectionBlockProperties,
} = doodBlockConfig(
  {
    name: "Kiosk - Loyalty Connection",
    componentType: "KioskLoyaltyConnectionBlockComponent",
    category: "kiosk",
    description: "Kiosk - Loyalty Connection.",
    keywords: [],
    allowedIn: [
      { bloc: 'KioskLoyaltyConnectionPageComponent', slot: 'body' },
    ],


    sharedFields: {},
  },

  () => ({
    title: propertyValue({
      type: "text",
      value: "",
      options: {
        label: "pages.blocks.kiosk-loyalty-connection.title.label",
      },
    }),
    first_card_label: propertyValue({
      type: "text",
      value: "",
      options: {
        label: "pages.blocks.kiosk-loyalty-connection.first-card-label.label",
      },
    }),
    first_card_link: propertyValue({
      type: "text",
      value: "",
      options: {
        label: "pages.blocks.kiosk-loyalty-connection.first-card-link.label",
        help: "pages.blocks.kiosk-loyalty-connection.first-card-link.help",
      },
    }),
    second_card_label: propertyValue({
      type: "text",
      value: "",
      options: {
        label: "pages.blocks.kiosk-loyalty-connection.second-card-label.label",
      },
    }),
    second_card_link: propertyValue({
      type: "text",
      value: "",
      options: {
        label: "pages.blocks.kiosk-loyalty-connection.second-card-link.label",
        help: "pages.blocks.kiosk-loyalty-connection.second-card-link.help",
      },
    }),
    display_third_card: propertyValue({
      type: "checkbox",
      value: false,
      options: {
        label: "pages.blocks.kiosk-loyalty-connection.display-third-card.label",
      },
    }),
    third_card_label: propertyValue({
      type: "text",
      value: "",
      options: {
        label: "pages.blocks.kiosk-loyalty-connection.third-card-label.label",
      },
    }),
    third_card_link: propertyValue({
      type: "text",
      value: "",
      options: {
        label: "pages.blocks.kiosk-loyalty-connection.third-card-link.label",
        help: "pages.blocks.kiosk-loyalty-connection.third-card-link.help",
      },
    }),
    heading_text_color: propertyValue({
      type: "color",
      value: { type: "palette", value: "primary-800" },
      options: {
        label: "pages.blocks.kiosk-loyalty-connection.heading-text-color.label",
      },
    }),
    main_card_background_color: propertyValue({
      type: "color",
      value: { type: "palette", value: "primary-800" },
      options: {
        label:
          "pages.blocks.kiosk-loyalty-connection.main-card-background-color.label",
      },
    }),
    main_card_text_color: propertyValue({
      type: "color",
      value: { type: "hex", value: "#FFFFFF" },
      options: {
        label:
          "pages.blocks.kiosk-loyalty-connection.main-card-text-color.label",
      },
    }),
    secondary_card_background_color: propertyValue({
      type: "color",
      value: { type: "hex", value: "transparent" },
      options: {
        label:
          "pages.blocks.kiosk-loyalty-connection.secondary-card-background-color.label",
      },
    }),
    secondary_card_text_color: propertyValue({
      type: "color",
      value: { type: "palette", value: "primary-800" },
      options: {
        label:
          "pages.blocks.kiosk-loyalty-connection.secondary-card-text-color.label",
      },
    }),
    third_card_background_color: propertyValue({
      type: "color",
      value: { type: "hex", value: "transparent" },
      options: {
        label:
          "pages.blocks.kiosk-loyalty-connection.third-card-background-color.label",
      },
    }),
    third_card_text_color: propertyValue({
      type: "color",
      value: { type: "palette", value: "primary-800" },
      options: {
        label:
          "pages.blocks.kiosk-loyalty-connection.third-card-text-color.label",
      },
    }),
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.kiosk-loyalty-connection.tab.content.label",
        fieldsets: [
          {
            legend:
              "pages.blocks.kiosk-loyalty-connection.fieldset.title.label",
            fields: ["title", "heading_text_color"],
          },
          {
            legend:
              "pages.blocks.kiosk-loyalty-connection.fieldset.main-card.label",
            fields: [
              "first_card_label",
              "first_card_link",
              "main_card_background_color",
              "main_card_text_color",
            ],
          },
          {
            legend:
              "pages.blocks.kiosk-loyalty-connection.fieldset.secondary-card.label",
            fields: [
              "second_card_label",
              "second_card_link",
              "secondary_card_background_color",
              "secondary_card_text_color",
            ],
          },
          {
            legend:
              "pages.blocks.kiosk-loyalty-connection.fieldset.third-card.label",
            fields: [
              "display_third_card",
              {
                prop: "third_card_label",
                visibleWhen: { display_third_card: true },
              },
              {
                prop: "third_card_link",
                visibleWhen: { display_third_card: true },
              },
              {
                prop: "third_card_background_color",
                visibleWhen: { display_third_card: true },
              },
              {
                prop: "third_card_text_color",
                visibleWhen: { display_third_card: true },
              },
            ],
          },
        ],
      },
    ],
  }),
);

export function kioskLoyaltyConnectionBlockDescriptor(): IBlockDescriptor;
export function kioskLoyaltyConnectionBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function kioskLoyaltyConnectionBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedKioskLoyaltyConnectionBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(
    _generatedKioskLoyaltyConnectionBlockDescriptor,
    kioskLoyaltyConnectionBlockProperties,
    fieldOrder,
  );
}

export {
  kioskLoyaltyConnectionBlockBlocDefinition,
  kioskLoyaltyConnectionBlockDashboardLayout,
  kioskLoyaltyConnectionBlockProperties,
  kioskLoyaltyConnectionBlockConfig,
  kioskLoyaltyConnectionBlockResolveConfig,
};

export type KioskLoyaltyConnectionBlockConfig =
  typeof kioskLoyaltyConnectionBlockConfig;
